<template>
	<b-card class="mb-2 shadow-sm bg-grey" border-variant="light">
		<h4 class="text-center">
			<b>Tu auto</b>
		</h4>
		<b-table-simple borderless class="mt-5">
			<b-tr>
				<b-td class="pb-0">
					Marca
				</b-td>
			</b-tr>
			<b-tr>
				<b-th class="text-right border-bottom-grey">
					{{data.brandText}}
				</b-th>
			</b-tr>
			<b-tr>
				<b-td class="pb-0">
					Año
				</b-td>
			</b-tr>
			<b-tr>
				<b-th class="text-right border-bottom-grey">
					{{data.yearText}}
				</b-th>
			</b-tr>
			<b-tr>
				<b-td class="pb-0">
					Modelo
				</b-td>
			</b-tr>
			<b-tr>
				<b-th class="text-right border-bottom-grey">
					{{data.modelText}}
				</b-th>
			</b-tr>
			<b-tr>
				<b-td class="pb-0">
					Versión
				</b-td>
			</b-tr>
			<b-tr>
				<b-th class="text-right border-bottom-grey">
					{{data.versionText}}
				</b-th>
			</b-tr>
			<b-tr>
				<b-td class="pb-0">
					Kilometraje
				</b-td>
			</b-tr>
			<b-tr>
				<b-th class="text-right border-bottom-grey">
					{{data.kmText}}
				</b-th>
			</b-tr>
		</b-table-simple>
	</b-card>
</template>

<script>
  export default {
	name: 'v-sell-car-data',
	props: {
		data: null
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>